import { render, staticRenderFns } from "./pictureCharts.vue?vue&type=template&id=1fe473ca&scoped=true"
import script from "./pictureCharts.vue?vue&type=script&lang=js"
export * from "./pictureCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe473ca",
  null
  
)

export default component.exports